export const STORAGE_KEYS = {
  TOKEN: "trivia-web-app-token",
  LANGUAGE: "language",
  SHOW_LOADING: "show_loading",
  LATEST_PAYMENT_ID: "latest-payment-id",
  LOGGED_IN_AS_GUEST: "loggedInAsGuest",
  SHOULD_FETCH_PLAYER_AGAIN: "should-fetch_player-again",
  PLAY_SOUNDS: "PLAY_SOUNDS"
};

export const MAIN_FONT_FAMILY = "Rubik";

export const APP_ICON_IMAGE = require("../../assets/images/app_icon.png");
export const APP_ICON_IMAGE_WITHOUT_TITLE = require("../../assets/images/app_icon_without_title.png");

export const ADMIN_PANEL_EMAIL = "admin@gmail.com"
export const ADMIN_PANEL_PASSWORD = "!Password123456"

export const MY_FATOORAH_ENVIRONMENT = "live"

export const CHARADES_CATEGORY_ID = "682c7aa189bc0e329db891b8"
export const CHARADES_QRCODE_LINK = "https://ellytbeeh.qa/qrcode/answers/{:id}"